import { graphql } from 'gatsby';
import React from 'react';

import styled from 'styled-components';
import { media } from '../components/_includes/Device';

import { JobHero } from '../components/JobHero';
import { JobInformation } from '../components/JobInformation';
import { RelatedJobs } from '../components/RelatedJobs';
import { JobShare } from '../components/JobShare';
import { JobBanner } from '../components/JobBanner';
import { JobForm } from '../components/JobForm';
import { ApplicationProcess } from '../components/ApplicationProcess';

import dotsGreen from '../assets/images/dots-green.svg';
import { connect } from 'react-redux';
import {
  mapDispatchToProps,
  mapStateToProps,
} from '../store';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 45px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  
  &:after {
      content: '';
      width: 400px;
      height: 400px;
      position: absolute;
      right: -40px;
      top: 200px;
      background-image: url('${dotsGreen}');
      background-repeat: no-repeat;
      z-index: -1;
    }
  
  > * {    
    &:first-child {
      max-width: calc(70%);
      width: calc(70%);
      flex-basis: calc(70%);
    }
    
    &:last-child {
      margin-left: 50px;
      max-width: calc(30%);
      width: calc(30%);
      flex-basis: calc(30%);
    }
  }
  
  ${media.tablet`
    padding: 35px 20px;
    display: block;
    
    &:after {
      top: auto;
      bottom: -20px;
      width: 300px;
      height: 100px;
    }
    
    > * {
      width: 100% !important;
      max-width: 100% !important;
      flex-basis: 100% !important;
      margin: 0 !important;
      
      &:first-child {
        margin-bottom: 35px;
      }
    }
  `}
`;

class Job extends React.Component {
  render () {
    let { data } = this.props;
    let { greenhouseJob, allPrismicDepartments } = data;
    let heroImage = '';
    let location = '';
    let link = this.props.location.href;
    let hashExists = this.props.location.hash !== '#form';
    let showBanner = false;

    this.props.setJobId(greenhouseJob.gh_Id);
    this.props.setJobTitle(greenhouseJob.title);
    this.props.setJobSlug(
      this.props.location.pathname.substring(
        5,
        this.props.location.pathname.length,
      ),
    );

    if (greenhouseJob.location) {
      location = greenhouseJob.location.name;
    }

    allPrismicDepartments.nodes.forEach(node => {
      if (greenhouseJob.departments[0].gh_Id === parseInt(node.uid)) {
        heroImage = node.data.hero_image.url;

        if (node.data.title.text === 'Technology & Engineering') {
          showBanner = true;
        }

        this.props.setJobTeam(node.data.title.text);
      }
    });

    return (
      <div>
        <JobHero
          title={greenhouseJob.title}
          heroImage={heroImage}
          location={location}
        />

        {showBanner && (
          <JobBanner />
        )}

        {hashExists && <JobInformation related={greenhouseJob} />}

        <Container>
          <JobForm job={greenhouseJob} />
          <ApplicationProcess />
        </Container>

        <RelatedJobs related={greenhouseJob} />

        <JobShare title={greenhouseJob.title} link={link} />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Job);

export const pageQuery = graphql`
  query JobById($gh_Id: Int!) {
    greenhouseJob(gh_Id: { eq: $gh_Id }) {
      id
      content
      title
      board_type
      gh_Id
      internal_job_id
      location {
        name
      }
      departments {
        gh_Id
        jobs {
          title
          slug
          id
          gh_Id
        }
      }
    }
    allPrismicDepartments {
      nodes {
        uid
        data {
          title {
            text
          }
          hero_image {
            url
            mobile {
              url
            }
          }
        }
      }
    }
  }
`;
